/**
 * The words on the page shown at / while HOMEPAGE_ENABLED is off.
 *
 * A SEPARATE FILE FROM homepage.ts ON PURPOSE. Sourcemaps carry the full text
 * of every file a bundle touches, so if these strings lived in homepage.ts,
 * the flag-off build would publish all of the homepage copy in its .map file,
 * including copy that has not been approved yet. Kept apart, the flag-off
 * build contains these strings and nothing else.
 */

/** The page <title>. Read at build time by vite.config.ts. */
export const placeholderMeta = {
  title: 'CI Sales Group',
}

export const placeholder = {
  wordmark: 'CI Sales Group',
  line: 'Our site is being updated.',
}
